import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { StorageService, StorageKey } from '../../core/services/storage.service';

/**
 * Guard for the direct POS entry route `/pos/s/:posStoreCode`.
 *
 * The edge-client shell (and any bookmarked terminal) deep-links straight
 * here. We persist the store code to storage *before* the PIN component
 * mounts or any bootstrap API call can fire, so every downstream
 * auth-failure redirect — the error interceptor, posGuard, posAuthGuard —
 * can always resolve the correct POS PIN screen and never fall through to
 * the admin `/login`.
 *
 * Always allows activation: the PIN screen IS the POS login surface, so
 * there is nothing to gate here — the guard exists purely to anchor the
 * standalone store context as early as possible in the navigation.
 */
export const posStandaloneGuard: CanActivateFn = (route) => {
  const storage = inject(StorageService);
  const code = route.paramMap.get('posStoreCode');
  if (code) {
    storage.setRaw(StorageKey.POS_STANDALONE_CODE, code);
  }
  return true;
};
